import api from './api';

/**
 * @param {Object} asset
 * @param {string} asset.name
 * @param {'images' | 'sounds'} asset.type
 * @param {boolean} [asset.createDbEntry]
 * @param {'ITEM' | 'MOTIVATIONAL'} asset.audio_type
 * @returns {Promise<{ signed_url: string }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Assets-PostAssets
 */
export default async function createAsset(asset) {
    const { data } = await api.post('assets', {
        asset_key: asset.name,
        create_db_entry: asset.createDbEntry ?? false,
        content_type: asset.type,
        audio_type: asset.audio_type,
    });
    return data;
}